import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "../components/AuthShell";
import OtpInput from "../components/OtpInput";
import {
  AUTH_STORAGE_KEYS,
  authTotpConfirm,
  establishWordPressSession,
  getAuthValue,
  setAuthFlowStep,
} from "../api/authApi";

export default function TotpConfirm() {
  const navigate = useNavigate();

  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const setupToken = getAuthValue(AUTH_STORAGE_KEYS.setupToken);
  const partnerId = getAuthValue(AUTH_STORAGE_KEYS.partnerId);

  useEffect(() => {
    if (!setupToken || !partnerId) {
      setError("Missing setup token or partner ID. Please log in again.");
      return navigate("/");
    }
  }, [setupToken, partnerId, navigate]);

  const handleConfirm = async (codeValue) => {
    const token = String(codeValue ?? code).trim();
    setError("");
    if (!token) {
      setError("Authentication code is required");
      return;
    }

    try {
      setLoading(true);
      await authTotpConfirm(setupToken, token);
      await establishWordPressSession();
      setAuthFlowStep("authenticated");
      navigate("/licences");
    } catch (e) {
      setError(e.message || "Unable to complete setup");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Confirm authenticator"
      subtitle="Enter the 6-digit code from your authenticator app."
    >
      <div className="mb-2">
        <OtpInput
          value={code}
          onChange={(next) => {
            if (error) setError("");
            setCode(next);
          }}
          disabled={loading}
        />
      </div>

      {error && (
        <div className="mt-2 text-[12px] text-red-600 text-center">{error}</div>
      )}

      <button
        type="button"
        onClick={() => handleConfirm()}
        disabled={loading}
        className={`w-full h-[44px] text-white px-[20px] mt-[15px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 ${
          loading
            ? "bg-[#cccccc] cursor-default opacity-60"
            : "bg-[#3d3935] border border-[#0f61a1] hover:opacity-80"
        }`}
      >
        {loading ? "Confirming..." : "Complete setup"}
      </button>

      <button
        type="button"
        onClick={() => {
          setAuthFlowStep("totp_setup");
          navigate("/2fa/setup");
        }}
        className="w-full h-[44px] bg-transparent border border-[#d2d2d2] text-[#3d3935] px-[20px] mt-[10px] inline-block text-center rounded-[20px] text-[13px] cursor-pointer transition-opacity duration-150 hover:opacity-80"
      >
        Back
      </button>
    </AuthShell>
  );
}